import { LANGUAGES } from 'services/translation'

import { Menu } from '../menu'
import { Footer } from '../footer'
import { Legal } from '../legal'

import './assets/language-selector.css'

const SELECTOR = '.o-lang-selector'
const CONTENT_SELECTOR = '.o-lang-selector__content'
const CURRENT_SELECTOR = '.o-lang-selector__current'
const DROPDOWN_SELECTOR = '.o-lang-selector__dropdown'
const LANG_SELECTOR = '[lang]'

let node
let changeLanguage
let applyTranslations
let currentLanguage
let dropdownClass = 'o-lang-selector__dropdown--hidden'
let open = false
let onLanguageChanged = null

function LanguageListItem({ lang }) {
  return `
    <li class="o-lang-selector__item">
      <button class="o-lang-selector__button" i18n="languages.${lang}" lang="${lang}"></button>
    </li>
  `.trim('')
}

function render() {
  node.innerHTML = `<div class="o-lang-selector__content">
      <button class="o-lang-selector__current" i18n="languages.${currentLanguage}"></button>
      <i class="o-lang-selector__icon icon ic-16-chevron-down"></i>
      <ul role="menu" class="o-lang-selector__dropdown o-lang-selector__dropdown--hidden">
      ${LANGUAGES.map((lang) => LanguageListItem({ lang })).join('')}
      </ul>
    </div>
  `
  declareListeners()
  applyTranslations()
}

function declareListeners() {
  declareDropdownListener()
  declareLanguageListeners()
  declareClickOutListener()
}

function declareDropdownListener() {
  const contentNode = document.querySelector(CONTENT_SELECTOR)
  contentNode.addEventListener('click', dropdownHandler)
}

function dropdownHandler() {
  const dropDownNode = document.querySelector(DROPDOWN_SELECTOR)
  toggledropdownClass(dropDownNode)
}

function toggledropdownClass(dropDownNode) {
  dropDownNode.classList.toggle(dropdownClass)
  open = !open
}

function declareLanguageListeners() {
  const nodes = document.querySelectorAll(LANG_SELECTOR)
  for (let i = nodes.length - 1; i >= 0; i -= 1) {
    nodes[i].addEventListener('click', languageClickHandler)
  }
}

function languageClickHandler(elem) {
  const language = elem.target.getAttribute('lang')

  if (!language) {
    return null
  }

  const currentNode = document.querySelector(CURRENT_SELECTOR)
  currentNode.setAttribute('i18n', `languages.${language}`)
  changeLanguage(language)
  currentLanguage = language
  Menu.render(currentLanguage)
  Footer.render(currentLanguage)
  Legal.render(currentLanguage)

  onLanguageChanged && onLanguageChanged()
}

function declareClickOutListener() {
  document.addEventListener('click', clickOutHandler)
}

function clickOutHandler(event) {
  const dropdownContentNode = document.querySelector(CONTENT_SELECTOR)
  const dropdownNode = document.querySelector(DROPDOWN_SELECTOR)
  const isClickOutside = !dropdownContentNode.contains(event.target)

  if (isClickOutside && open) {
    return toggledropdownClass(dropdownNode)
  }
}

function removeDropdownListener() {
  const contentNode = document.querySelector(CONTENT_SELECTOR)
  contentNode.removeEventListener('click', dropdownHandler)
}

function removeClickOutListener() {
  document.removeEventListener('click', clickOutHandler)
}

const LanguageSelector = {
  initialize(_currentLanguage, _changeLanguage, _applyTranslations) {
    node = document.querySelector(SELECTOR)
    changeLanguage = _changeLanguage
    currentLanguage = _currentLanguage
    applyTranslations = _applyTranslations

    render()
  },
}

export const deleteDropdownListener = removeDropdownListener
export const deleteClickOutListener = removeClickOutListener
export const addDropdownListener = declareDropdownListener
export const addClickoutListener = declareClickOutListener
export const setChangedLanguageCallback = (callback) =>
  (onLanguageChanged = callback)

export default LanguageSelector
